import { render } from "./UserManagement.vue?vue&type=template&id=c3a23976&scoped=true&ts=true"
import script from "./UserManagement.vue?vue&type=script&lang=ts"
export * from "./UserManagement.vue?vue&type=script&lang=ts"

import "./UserManagement.vue?vue&type=style&index=0&id=c3a23976&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a23976"]])

export default __exports__